import styled from 'styled-components';
import { Tab } from 'semantic-ui-react';

export const Container = styled.div`
  display: flex;
  width: 100%;
`;

export const TabMenu = styled(Tab)`
  width: 100%;
  .ui.secondary.menu .active.item {
    background: ${(props) => props.theme.color.highlight};
  }
`;
